import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, catchError, map, throwError } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  private storageService = inject(LocalStorageService);

  private router = inject(Router);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.storageService.getFromStorage('token');

    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'bearer ' + token),
      });
    }

    if (!request.headers.has('Accept')) {
      request = request.clone({
        headers: request.headers.set('Accept', 'application/json'),
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Additional success logic can go here
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let errorDetails;
        try {
          errorDetails = JSON.parse(error.error);
        } catch {
          errorDetails = { detail: 'Unexpected error' };
        }

        if (error.status === 500) {
        }
        return throwError(() => error);
      })
    );
  }
}
